"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * This class is used to parse store availability data for IRW.
 */
var IrwStoreAvailabilityParser = /*#__PURE__*/function () {
  function IrwStoreAvailabilityParser() {
    _classCallCheck(this, IrwStoreAvailabilityParser);
  }

  _createClass(IrwStoreAvailabilityParser, null, [{
    key: "parse",

    /**
     * Parses availability data.
     *
     * @param {Object} data Data to parse.
     * @return {Object|Null} Parsed data.
     */
    value: function parse(data) {
      data = data.StockAvailability;

      if (data) {
        var itemNo = data.ItemKey && data.ItemKey.ItemNo && data.ItemKey.ItemNo.$ ? data.ItemKey.ItemNo.$ : null;
        var itemType = data.ItemKey && data.ItemKey.ItemType && data.ItemKey.ItemType.$ ? data.ItemKey.ItemType.$ : null;
        var stockAvailability = data.RetailItemAvailability && data.RetailItemAvailability.AvailableStock && data.RetailItemAvailability.AvailableStock.$ ? data.RetailItemAvailability.AvailableStock.$ : null;
        var inStockProbabilityCode = data.RetailItemAvailability && data.RetailItemAvailability.InStockProbabilityCode && data.RetailItemAvailability.InStockProbabilityCode.$ ? data.RetailItemAvailability.InStockProbabilityCode.$ : null;
        var availability = {
          ID: String(itemNo),
          Type: itemType,
          StockAvailability: stockAvailability,
          SalesLocation: null,
          InStockProbabilityCode: inStockProbabilityCode
        };

        if (availability.Type === 'SPR') {
          var childAvailability = data.RetailItemAvailability && data.RetailItemAvailability.RetailItemCommChildAvailabilityList && data.RetailItemAvailability.RetailItemCommChildAvailabilityList.RetailItemCommChildAvailability ? data.RetailItemAvailability.RetailItemCommChildAvailabilityList.RetailItemCommChildAvailability : [];
          availability.ChildAvailabilityList = [];

          if (childAvailability.constructor === Array) {
            var _iterator = _createForOfIteratorHelper(childAvailability),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var child = _step.value;
                availability.ChildAvailabilityList.push(this._getChildItem(child));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else {
            // This should not happen. An SPR should have more than one child
            availability.ChildAvailabilityList.push(this._getChildItem(childAvailability));
          }
        } else {
          this._applyCodeAndLocation(availability, data.RetailItemAvailability);
        }

        return availability;
      }

      return null;
    }
    /**
     * Returns child item availability.
     *
     * @param {Object} data Data to parse.
     * @return {Object} Child item availability data.
     */

  }, {
    key: "_getChildItem",
    value: function _getChildItem(data) {
      var availability = {
        ID: String(data.ItemNo.$),
        Type: data.ItemType.$,
        SalesLocation: null
      };

      this._applyCodeAndLocation(availability, data);

      return availability;
    }
    /**
     * Applies code and location to availability data object.
     *
     * @param {Object} availability Availability data.
     * @param {Object} data Data object.
     */

  }, {
    key: "_applyCodeAndLocation",
    value: function _applyCodeAndLocation(availability, data) {
      var recommendedSalesLocation = data.RecommendedSalesLocation && data.RecommendedSalesLocation.$ ? data.RecommendedSalesLocation.$ : null;

      switch (Number(data.SalesMethodCode.$)) {
        case 0:
          availability.SalesMethodCode = 'SATELLITE';
          availability.SalesLocation = this._getSalesLocation(availability.SalesMethodCode, recommendedSalesLocation);
          break;

        case 1:
          availability.SalesMethodCode = 'SELF_SERVE';
          availability.SalesLocation = this._getSalesLocation(availability.SalesMethodCode, recommendedSalesLocation);
          break;

        case 2:
          availability.SalesMethodCode = 'FULL_SERVE'; // contact co-worker

          break;

        case 3:
          availability.SalesMethodCode = 'DDS'; // contact co-worker

          break;
      }
    }
    /**
     * Returns sales location.
     *
     * @param {String} method Method to use.
     * @param {String} location Location to use.
     * @return {Object} Sales location object.
     */

  }, {
    key: "_getSalesLocation",
    value: function _getSalesLocation(method, location) {
      if (method === 'SATELLITE' && location) {
        return {
          Department: String(location)
        };
      } else if (method === 'SELF_SERVE' && location) {
        location = String(location);

        if (!isNaN(location) && location.length === 6) {
          return {
            Aisle: location.substr(0, 2),
            Bin: location.substr(2, 2)
          };
        }

        if (location.length === 3 && !isNaN(location.substr(0, 2))) {
          return {
            Aisle: location.substr(0, 2),
            Bin: location.substr(2, 1)
          };
        }
      }

      return null;
    }
  }]);

  return IrwStoreAvailabilityParser;
}();

exports.default = IrwStoreAvailabilityParser;